import script from "./Stages.vue?vue&type=script&setup=true&lang=js"
export * from "./Stages.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Stages.vue?vue&type=style&index=1&id=0a1d0204&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1d0204"]])

export default __exports__